import * as React from 'react';
import { cn } from '@/lib/utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('text-xs font-medium text-foreground', className)}
      {...props}
    >
      {children}
    </label>
  ),
);
Label.displayName = 'Label';
